function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 78,
  height: 71,
  rx: 16,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.505 49.553a1.68 1.68 0 001.68-1.68V29.448l6.367 6.829a1.68 1.68 0 102.453-2.293l-9.27-9.95a1.68 1.68 0 00-2.456 0l-9.274 9.95a1.68 1.68 0 002.457 2.293l6.363-6.83v18.426a1.68 1.68 0 001.68 1.68z",
  fill: "#374A52"
});

function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79 72",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgUpArrow;